"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapWithProviders = void 0;

var _screenRecognition = require("@phx-husky/screen-recognition");

var _react = _interopRequireDefault(require("react"));

var _ExternalLinkDialogContext = _interopRequireDefault(require("~/context/ExternalLinkDialogContext"));

var _shopify = require("~/context/shopify");

const wrapWithProviders = ({
  element
}) => {
  const StoreProvider = process.env.GATSBY_SHOPIFY_STORE_URL && process.env.GATSBY_STOREFRONT_ACCESS_TOKEN ? _shopify.StoreProvider : _react.default.Fragment;
  return /*#__PURE__*/_react.default.createElement(_screenRecognition.ScreenRecognitionProvider, null, /*#__PURE__*/_react.default.createElement(_ExternalLinkDialogContext.default, null, /*#__PURE__*/_react.default.createElement(StoreProvider, null, element)));
};

exports.wrapWithProviders = wrapWithProviders;